module.exports = __webpack_public_path__ + "static/media/partner.a8cb7d34.svg";